"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZERO = void 0;
exports.computeLine = computeLine;
const decimal_js_1 = require("decimal.js");
const NULL_RESULT = {
    plannedQuantityRaw: null,
    performanceRatioRaw: null,
    deviationRaw: null,
    earnedStandardMinutes: null,
};
/**
 * Direct implementation of FORMULA_AND_CALCULATION_MAP.md §1.2, generalized
 * (never hardcodes 450 — always uses the norm snapshot's baseDurationMinutes).
 *
 * plannedQuantityRaw    = standardQuantity / baseDurationMinutes * durationMinutes
 * deviationRaw          = (reportedQuantity - plannedQuantityRaw) / plannedQuantityRaw
 * performanceRatioRaw   = deviationRaw + 1
 * earnedStandardMinutes = reportedQuantity * baseDurationMinutes / standardQuantity
 *
 * No intermediate rounding — raw Decimal values flow through unrounded
 * (CALCULATION_ENGINE_ARCHITECTURE.md §6).
 */
function computeLine(input) {
    const { standardQuantity, baseDurationMinutes, durationMinutes, reportedQuantity } = input;
    // Guard: never attempt division when the norm snapshot itself is missing/zero
    // (reproduces the intent of avoiding #DIV/0!, EXCEL_FORENSIC_ANALYSIS.md §7).
    if (standardQuantity === null ||
        standardQuantity.isZero() ||
        baseDurationMinutes === null ||
        baseDurationMinutes.isZero()) {
        return { ...NULL_RESULT };
    }
    const plannedQuantityRaw = standardQuantity.div(baseDurationMinutes).mul(durationMinutes);
    const earnedStandardMinutes = reportedQuantity.mul(baseDurationMinutes).div(standardQuantity);
    // Edge case: durationMinutes = 0 -> plannedQuantityRaw = 0. If the worker still
    // reported a non-zero quantity, a ratio against a zero planned amount is not
    // meaningful — flag as "not applicable" rather than dividing by zero.
    if (plannedQuantityRaw.isZero()) {
        if (!reportedQuantity.isZero()) {
            return {
                plannedQuantityRaw,
                performanceRatioRaw: null,
                deviationRaw: null,
                earnedStandardMinutes,
            };
        }
        return {
            plannedQuantityRaw,
            performanceRatioRaw: null,
            deviationRaw: null,
            earnedStandardMinutes,
        };
    }
    const deviationRaw = reportedQuantity.sub(plannedQuantityRaw).div(plannedQuantityRaw);
    const performanceRatioRaw = deviationRaw.add(1);
    return {
        plannedQuantityRaw,
        performanceRatioRaw,
        deviationRaw,
        earnedStandardMinutes,
    };
}
exports.ZERO = new decimal_js_1.Decimal(0);
//# sourceMappingURL=line-formula.js.map